import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      natvieDevices: ['ios', 'android'],
      isNative: false
    }
  },
  created() {
    // detect on clien side
    const { device } = this.$route.query
    this.isNative = this.natvieDevices.includes(device)
  },
  computed: {
    ...mapGetters(['isNativeDevice'])
  }
}
